import React from 'react';
import { createStyles, ExtractStylesClassGetter } from 'app/utils/css';
import Link from 'app/components/presentation/link/Link';
import RedirectingPage from 'app/components/pages/RedirectingPage';
import OauthAttachCallback from 'app/components/auth/OauthAttachCallback';
import {
  AUTH_ACTION_LINK,
  AUTH_ALERT_CONTAINER_STYLE,
  AUTH_ERROR_STYLE,
} from 'app/components/auth/AuthStyles';
import { EditProfileRoute } from 'app/constants/Routes';
import { T, tFunctionType } from 'app/components/localization';
import { UidTakenError } from 'app/services/oauth/attach';
import Page from 'app/components/layout/Page';
import MarginGroup from 'app/components/layout/MarginGroup';
import CryingOwl from 'app/components/svgs/mascot/Crying';
import PageContent from 'app/components/presentation/containers/page/PageContent';
import FormSectionCard from 'app/components/presentation/containers/FormSectionCard';
import { FACEBOOK } from 'app/constants/enums/AuthProvider';

const Styles = createStyles({
  profileLink:  {
    ...AUTH_ACTION_LINK,
  },
  errorMessage: {
    ...AUTH_ERROR_STYLE,
    ...AUTH_ALERT_CONTAINER_STYLE,
  },
  owl:          {
    textAlign: 'center',
  },
});

const OauthAttachCallbackPage = () => (
  <OauthAttachCallback>{({ error }) => {
    if (error) {
      return (
        <T>{(t) =>
          <Styles>{(css) =>
            <Page
              title={t('page.oauth-attach-callback.title')}
            >
              <PageContent>
                {renderError(error, css, t)}
              </PageContent>
            </Page>
          }</Styles>
        }</T>
      );
    } else {
      return <RedirectingPage />;
    }
  }}</OauthAttachCallback>
);

function renderError(
  error: unknown,
  css: ExtractStylesClassGetter<typeof Styles>,
  t: tFunctionType,
) {
  let title: string;
  let message: string;

  if (error instanceof UidTakenError) {
    if (error.provider === FACEBOOK) {
      title   = t('page.oauth-attach-callback.uid-taken-error-facebook-title');
      message = t('page.oauth-attach-callback.uid-taken-error-facebook-message');
    } else {
      title   = t('page.oauth-attach-callback.uid-taken-error-generic-title');
      message = t('page.oauth-attach-callback.uid-taken-error-generic-message',
        { provider: error.provider.getName(t) });
    }
  } else {
    // This is not something the user can cause. The error message
    // doesn't have to be specific or actionable.
    title   = t('page.oauth-attach-callback.generic-error-title');
    message = t('page.oauth-attach-callback.generic-error-message');
  }

  return (
    <FormSectionCard header={title}>
      <MarginGroup>
        <div className={css('owl')}>
          <CryingOwl width={'50%'} />
        </div>
        <div className={css('errorMessage')}>
          {message}
        </div>
        <Link to={EditProfileRoute.getPathname()} className={css('profileLink')}>
          {t('page.oauth-attach-callback.back-to-profile')}
        </Link>
      </MarginGroup>
    </FormSectionCard>
  );
}

export default OauthAttachCallbackPage;
